import { render, staticRenderFns } from "./BankPicker.vue?vue&type=template&id=2587086d&scoped=true&"
import script from "./BankPicker.vue?vue&type=script&lang=js&"
export * from "./BankPicker.vue?vue&type=script&lang=js&"
import style0 from "./BankPicker.vue?vue&type=style&index=0&id=2587086d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587086d",
  null
  
)

export default component.exports